import type { DXPLandingState, DXPLandingActions } from "./types";

const INITIAL_STATE: DXPLandingState = {
  loading: false,
  error: false,
  data: {
    headline: "",
    image: "",
    banner_section_1: "",
    banner_section_2: "",
    google_playstore_icon: "",
    google_playstore_link: "",
    apple_store_icon: "",
    apple_store_link: "",
    color: "",
    faq_label: "",
    faq_lists: [],
    new_features: [],
    new_features_desc: "",
    other_features: [],
    other_features_desc: "",
    user_guide_lists: [],
    user_guide_label: "",
    exist_customer_steps: [],
    exist_customer_label: "",
    new_customer_label: "",
    new_customer_steps: [],
    show_user_guide: "false",
  },
};

export default (
  state: DXPLandingState = INITIAL_STATE,
  action: DXPLandingActions
): DXPLandingState => {
  switch (action.type) {
    case "REQUEST_DXP_LANDING_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case "REQUEST_DXP_LANDING_FAILED": {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case "REQUEST_DXP_LANDING_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
